import { create} from "zustand"
import CommandIdEnum from "../enums/CommandIdEnums";

export interface CurrentCommandState
{
    commandId: CommandIdEnum | null;
    commandNameResourceKey: string;
    commandPromptResourceKey: string;
    commandInfoVisible: boolean;
    switchPlaneBtnVisible: boolean;
    onSwitchPlane: (() => void) | null;
    nextBtnVisible: boolean;
    nextBtnEnabled: boolean;
    nextBtnLabelResourceKey: string;
    onNext: (() => void) | null;
    measureText: string | null;
    canvasCursor: string;

    setCurrentCommand: (id: CommandIdEnum, name: string, prompt: string, visible?: boolean) => void;
    clearCurrentCommand: () => void;

    setCurrentCommandPrompt: (prompt: string) => void;
    clearCurrentCommandPrompt: () => void;

    showSwitchPlaneButton: (callback: () => void) => void;
    hideSwitchPlaneButton: () => void;

    showNextButton: (callback: () => void, labelResourceKey: string, enabled?: boolean) => void;
    setNextButtonEnabled: (enabled: boolean) => void;
    hideNextButton: () => void;

    setMeasureText: (text: string) => void;
    clearMeasureText: () => void;

    setCanvasCursor: (cursor: string) => void;
    clearCanvasCursor: () => void;
}

export const useCurrentCommandState = create<CurrentCommandState>()(
    (set) => ({
        commandId: null,
        commandNameResourceKey: "",
        commandPromptResourceKey: "",
        commandInfoVisible: true,
        switchPlaneBtnVisible: false,
        onSwitchPlane: null,
        nextBtnVisible: false,
        nextBtnEnabled: false,
        nextBtnLabelResourceKey: "",
        onNext: null,
        measureText: null,
        canvasCursor: 'default',

        setCurrentCommand: (id: CommandIdEnum, nameResourceKey: string, promptResourceKey: string = "", visible: boolean = true) => 
            set({   commandId: id, 
                    commandNameResourceKey: nameResourceKey, 
                    commandPromptResourceKey: promptResourceKey,
                    commandInfoVisible: visible }),

        clearCurrentCommand: () => 
            set({   commandId: null, 
                    commandNameResourceKey: "", 
                    commandPromptResourceKey: "",
                    commandInfoVisible: true }),

        setCurrentCommandPrompt: (promptResourceKey: string) => 
            set({ commandPromptResourceKey: promptResourceKey }),

        clearCurrentCommandPrompt: () => 
            set({ commandPromptResourceKey: "" }),

        showSwitchPlaneButton: (callback: () => void) =>
            set({ switchPlaneBtnVisible: true, onSwitchPlane: callback }),

        hideSwitchPlaneButton: () =>
            set({ switchPlaneBtnVisible: false, onSwitchPlane: null }),

        showNextButton: (callback: () => void, labelResourceKey: string, enabled: boolean = true) =>
            set({ nextBtnVisible: true, nextBtnEnabled: enabled, nextBtnLabelResourceKey: labelResourceKey, onNext: callback }),

        setNextButtonEnabled: (enabled: boolean) =>
            set({ nextBtnEnabled: enabled }),

        hideNextButton: () =>
            set({ nextBtnVisible: false, nextBtnEnabled: false, nextBtnLabelResourceKey: "", onNext: null }),

        setMeasureText: (text: string) =>
            set({ measureText: text }),

        clearMeasureText: () =>
            set({ measureText: null }),

        setCanvasCursor: (cursor: string) =>
            set({ canvasCursor: cursor }),

        clearCanvasCursor: () =>
            set({ canvasCursor: 'default' }),
    })
);


